import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo(0, 0);
    navigate(`/articolo/${slug}`);
  };

  const displayArticles = articles.slice(0, 9);

  return (
    <section className="w-full bg-background-100 py-20 md:py-28" id="articoli">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="text-xs tracking-[0.15em] uppercase text-foreground-500 font-label">
            Blog SEO
          </span>
          <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading">
            Ultime Guide{' '}
            <span className="italic font-normal">Itaobuy Spreadsheet</span>
          </h2>
          <p className="mt-3 text-base text-foreground-600 max-w-2xl mx-auto font-body">
            Articoli, tutorial e approfondimenti originali per conoscere a fondo itaobuy sheet e utilizzarlo al meglio.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article) => (
            <article
              key={article.slug}
              onClick={() => handleArticleClick(article.slug)}
              className="group rounded-2xl bg-background-50 border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-300/60 transition-all duration-300 flex flex-col"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full font-label self-start">
                  {article.category}
                </span>
                <h3 className="mt-3 text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 font-body leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-400 font-body">
                  <span>{article.readTime}</span>
                  <span className="flex items-center gap-1 text-primary-500 font-medium">
                    Leggi
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {articles.length > 9 && (
          <div className="mt-10 text-center">
            <a
              href="#articoli"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap font-label"
            >
              Vedi tutti gli articoli
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}